<template>
  <div class="profile-parent">
    <div
      class="profile-picture"
      :class="{'first-profile': isFirstProfile}"
    >
      <img :src="profile.avatarfull">
      <div
        class="overlay"
        @click="removeProfile"
      >
        <div class="text">
          <span class="icon is-small is-left">
            <i class="fas fa-times" />
          </span>
        </div>
      </div>
    </div>
    <div id="details">
      <div id="vanity">
        <a
          :href="profile.profileurl"
          target="_blank"
        >{{ profile.personaname }}</a>
      </div>
      <div id="count">
        games owned:
        {{ profile.game_count }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Profile",
  props: {
    profile: {
      type: Object,
      default: null
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      isFirstProfile: false
    };
  },
  created: function() {
    if (this.id === 0) {
      this.isFirstProfile = true;
    }
  },
  methods: {
    removeProfile: function() {
      this.$emit("removeProfile", this.profile);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.profile-picture, .first-profile {
  display: flex;
}

.profile-parent {
  display: flex;
  flex-direction: row;
  margin: 0 0 1em;
  align-items: center;
}
.text {
  font-size: 60px;
  text-align: center;
  line-height: 140px;
  opacity: 0.5;
}

.profile-picture:hover .overlay {
  opacity: 1;
  cursor: pointer;
}

.first-profile:hover .overlay {
  opacity: 0;
  cursor: default;
}

.profile-parent p {
  margin-left: 0.5em;
  font-size: 1.25em;
}
.profile-parent img {
  width: 120px;
  height: 120px;
  display: block;
}

#details {
  margin-left: 1em;
}
#vanity {
  font-size: 1.25em;
}
#count {
  color: grey;
}

.overlay {
  position: absolute;
  width: 120px;
  height: 120px;
  opacity: 0;
  transition: 0.5s ease;
  background-color: white;
}
a:link,
a:visited {
  color: black;
}
a:hover {
  color: #3273dc;
}

@media only screen and (max-width: 640px) {
  .profile-parent img {
    width: 100px;
    height: 100px;
  }
  .text {
    font-size: 40px;
    line-height: 120px;
  }
  .overlay {
    width: 100px;
    height: 100px;
  }
}
</style>